import { render, staticRenderFns } from "./HealthDeclaration.vue?vue&type=template&id=3edcfbf6&"
import script from "./HealthDeclaration.vue?vue&type=script&lang=js&"
export * from "./HealthDeclaration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports